import * as z from 'zod';

export const UserGroupMemberSchema = z.object({
  id: z.string(),
  userId: z.string(),
  groupId: z.string(),
  seq: z.string(),
});

export type UserGroupMemberType = z.infer<typeof UserGroupMemberSchema>;
